import {
  createRoutesFromElements,
  RouterProvider,
  Route,
  createBrowserRouter,
} from "react-router-dom";
import ShopGroup from "./components/ShopGroup/ShopGroup";
import Auth from "./components/Auth/Auth";
import RootLayout from "./RootLayout";
import ShopItem from "./components/ShopItem/ShopItem";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<ShopGroup />}/> 
      <Route path="groups/:id" element={<ShopItem/>}/>
      <Route path="/auth" element={<Auth/>}/>
      <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
    </Route>
  )
);
function App() {
  return <RouterProvider router={router} />;
}

export default App;
